import FlexBox from '@/atomic-components/FlexBox';
import { ICartItem, LineOfProduct } from '@/services/cart/models/cart';
import { getColor } from '@/utils/theme/colors';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import { Box } from '@mui/system';
import { useCart } from '@/hooks/useCart';
import TenureSelectorDropdown from '@/components/TenureSelectorDropdown';
import UpdateQuantityButton from '@/components/UpdateQuantityButton';
import { useFullScreenLoader } from '@/hooks/useFullScreenLoader';
import { useNotification } from '@/hooks/useNotification';
import { NotificationSeverity } from '@/components/NotifyToast';
import { AvailableStockCountLabel } from '@/components/ProductDisplayPage/Components/SideBar/AvailableStockCountLabel';

type ActionsForCartItemInStockProps = {
	item: ICartItem;
	isUpdatingQuantity: boolean;
	openTenureSelector: () => void;
	updateCartItemQuantity: (newQuantity: number) => void;
	labels?: any;
	vertical?: any;
};

const ActionsForCartItemInStock = (props: ActionsForCartItemInStockProps) => {
	const tenureVisible =
		props.item?.upfrontOffer?.tenureSelector?.upfrontPaymentPlans?.paymentPlans;

	const showEmptyState =
		!tenureVisible ||
		(Array.isArray(tenureVisible) && tenureVisible.length === 0);
	const { item, openTenureSelector } = props;
	useCart();

	const { actions } = useNotification();
	const stockLimitReached = item.availableQuantity == 0 && !item?.isOutOfStock;
	const lowStockAvailability =
		item.availableQuantity > 0 && item.availableQuantity < 10;

	function updateCartItemQuantityBy1(action: 'ADD' | 'REMOVE') {
		const change = action === 'ADD' ? 1 : -1;
		let newQuantity = item.quantity + change;

		props.updateCartItemQuantity(newQuantity);
	}

	function addQuantityBy1() {
		if (item.availableQuantity < 1) {
			actions.notifyUser({
				severity: NotificationSeverity.WARNING,
				message:
					"You have added the maximum quantity available to your cart!  That's all we have for you at the moment!",
			});

			return;
		}
		updateCartItemQuantityBy1('ADD');
	}
	function reduceQuantityBy1() {
		updateCartItemQuantityBy1('REMOVE');
	}

	return (
		<>
			<Box>
				<FlexBox direction='column' mr='8px' justifyContent='end'>
					{!showEmptyState && item.lineOfProduct == LineOfProduct.RENT && (
						<Box height='40px'>
							<TenureSelectorDropdown
								labels={props?.labels}
								currentTenure={item.tenure}
								openTenureSelector={openTenureSelector}
							/>
						</Box>
					)}
					<Box height='40px'>
						<UpdateQuantityButton
							isLoading={props.isUpdatingQuantity}
							amount={item.quantity}
							onAdd={addQuantityBy1}
							onReduce={reduceQuantityBy1}
							availableQuantity={item.availableQuantity}
						/>
					</Box>
					{stockLimitReached && (
						<LencoTypography
							mt='8px'
							variant='Small_Regular'
							color={getColor('Danger -2')}
						>
							Stock limit reached!
						</LencoTypography>
					)}
				</FlexBox>
			</Box>
		</>
	);
};

export default ActionsForCartItemInStock;
